import { render, staticRenderFns } from "./ContactCentre.vue?vue&type=template&id=135d991e&scoped=true&"
import script from "./ContactCentre.vue?vue&type=script&lang=js&"
export * from "./ContactCentre.vue?vue&type=script&lang=js&"
import style0 from "./ContactCentre.vue?vue&type=style&index=0&id=135d991e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135d991e",
  null
  
)

export default component.exports